import { useParams } from "react-router-dom";
import { AuditLogResponse } from "datasets/types/interfaces/audit-log";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

interface UseAuditLogParams {
  limit?: number;
  offset?: number;
  sort?: string;
}

const useAuditLog = ({ limit = 20, offset = 0, sort = "-timestamp" }: UseAuditLogParams = {}) => {
  const { datasetId } = useParams();

  const query = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
    sort,
  });

  return useFetcher<AuditLogResponse>(
    datasetId ? `${VITE_CATALOG_API}/v1/datasets/${datasetId}/audit-log?${query.toString()}` : null,
    // keepPreviousData holds the current page's rows while the next page loads, so
    // paging doesn't flash the loading skeleton or drop the pagination footer.
    { revalidateOnFocus: false, keepPreviousData: true }
  );
};

export default useAuditLog;
